export const initialState = {
  relatedContractsData: [],
  relatedContractsCount: 0,
  relatedContractsLoading: false,
};
